module.exports = {
    className: "TierBlockMessage",
    classNameLabel: "Tier Block Message",
    limit: 10,
    showExport: false,
    showCreate: false,
    showDelete: false,
    columns: [
        {
            columnName: "objectId",
            type: "string"
        },
        {
            columnName: "title",
            type: "string"
        },
        {
            columnName: "content",
            type: "string"
        },
        {
            columnName: "browser",
            type: "string",
            show: false
        },
        {
            columnName: "url",
            type: "string",
            show: false
        },
        {
            columnName: "createdAt",
            type: "Date"
        },
        {
            columnName: "updatedAt",
            type: "Date"
        }
    ]
}


// WEBPACK FOOTER //
// ./components/TierBlockMessage/TierBlockMessageSchema.js